import getCSRF from "./get-csrf.js";
import login from "./login.js";
import token from "./token.js";
import logout from "./logout.js";

export default {
	getCSRF,
	login,
	token,
	logout,
};
